import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http:HttpClient) { }


  GetCustomerDashboard( Token:String):Observable<any>{
    return this.http.get(environment.BaseUrl+ "Daro/Dashboard/GetCustomerDashboard?token="+Token).pipe(
      map(data=>{
        return data as any
      })
    )
  }

  GetExpertDashboard(Type:number, Token:String):Observable<any>{
    return this.http.get(environment.BaseUrl+ "Daro/Dashboard/GetExpertDashboard?token="+Token+"&Type="+Type).pipe(
      map(data=>{
        return data as any
      })
    )
  }

  GetSuggest( Token:String):Observable<any>{
    return this.http.get(environment.BaseUrl+ "Daro/Dashboard/GetSuggest?token="+Token).pipe(
      map(data=>{
        return data as any
      })
    )
  }

}
